import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-432c79c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-profile-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col location" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Location", -1))
const _hoisted_6 = ["readonly"]
const _hoisted_7 = { class: "help-text" }
const _hoisted_8 = {
  key: 1,
  class: "row"
}
const _hoisted_9 = { class: "col col-sm-3 social-accounts" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Social accounts", -1))
const _hoisted_11 = { class: "list-unstyled" }
const _hoisted_12 = ["src", "alt"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "@", -1))
const _hoisted_14 = ["value", "onInput"]
const _hoisted_15 = {
  key: 2,
  class: "row input-row"
}
const _hoisted_16 = { class: "col col-sm-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "startYearInput",
  class: "form-label"
}, "Genealogist since", -1))
const _hoisted_18 = ["readonly"]
const _hoisted_19 = { class: "big-number" }
const _hoisted_20 = { class: "secondary-text" }
const _hoisted_21 = {
  key: 3,
  class: "row"
}
const _hoisted_22 = { class: "col research-tools" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Research tools", -1))
const _hoisted_24 = { class: "list-unstyled" }
const _hoisted_25 = { class: "add-tool" }
const _hoisted_26 = {
  key: 0,
  type: "button",
  class: "btn btn-outline-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#researchToolsModal"
}

import { computed, reactive, ref, watch } from 'vue'
import { useUserStore } from '@/gp/UserStore'
import { useIdentityApi } from '@/auth/IdentityApi'
import { ItemPermissions, socialAccountProviders, UserMetadata } from '@/gp/GroupAdminModel'
import { researchToolInfos } from '@/rd/ResearchTools'
import { propertyChanged, useEditMode } from '@/util/EditMode'
import { useTokenManager } from '@/auth/TokenManager'
import { LoadMode } from '@/util/AsyncData'
import { PatchChange, PatchChangeValue } from '@/util/Api'
import { DateTime } from 'luxon'
import EditActions from '@/util/EditActions.vue'
import ResearchToolItem from './ResearchToolItem.vue'
import ResearchToolsModal from './ResearchToolsModal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserProfileContent',
  props: {
    userId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  canEdit: () => canEdit.value,
  edit: () => edit(),
})

const suggestedLocationRef = ref<string>()

const userStore = useUserStore()
const identityApi = useIdentityApi()
const tokenManager = useTokenManager()

const userIdRef = computed(() => props.userId ?? tokenManager.current.userId!)
const userRef = computed(() => userStore.getAsyncUser(userIdRef.value)?.data)
const metadataRef = computed(() => userRef.value?.metadata)

const startYearAgoRef = computed(() => DateTime.now().year - (metadataRef.value?.genealogyStartYear ?? 0))

const researchToolsRef = computed({
  get: () => {
    const metadata = isEditing.value ? editMetadata : metadataRef.value
    const toolIds = metadata?.researchTools ?? []
    return researchToolInfos.filter(t => toolIds.includes(t.id)).map(t => t.id) // in display order
  },
  set: value => {
    editMetadata.researchTools = value
  }
})

const editMetadata = reactive(new UserMetadata())
const editProperties = [
  'location',
  'genealogyStartYear',
  'researchTools', 
  'showResearchActivity',
  'showFamilySurnames',
  'socialAccounts',
] as (keyof UserMetadata)[]

const allowEdit = computed(() => {
  const perms = userStore.getAsyncPermissions(userIdRef.value, LoadMode.EnsureLoaded)?.data ?? ItemPermissions.None
  return (perms & ItemPermissions.Modify) > 0
})
const allowSave = computed(() => true)

const { canEdit, canEditValues, isEditing, edit, canSave, saveText, saveChanges, canCancel, cancel } = 
  useEditMode(metadataRef, editMetadata, editProperties, allowEdit, allowSave)

watch([userRef, allowEdit], async () => {
  if (userRef.value && allowEdit.value) {
    const ident = await identityApi.getIdentityAsync(userRef.value.subject!)
    suggestedLocationRef.value = ident?.metadata?.clientLocationName
  }
}, { immediate: true })

function useSuggestedLocation() {
  editMetadata.location = suggestedLocationRef.value
}

function onSocialAccountChange(e: Event, providerId: string) {
  const input = e.target as HTMLInputElement
  const value = input.value.trim()
  const accountIndex = editMetadata.socialAccounts?.findIndex(a => a.startsWith(providerId + ':')) ?? -1
  if (value == '') {
    if (accountIndex >= 0) {
      editMetadata.socialAccounts?.splice(accountIndex, 1) // remove account
    }
  }
  else {
    if (accountIndex >= 0) {
      editMetadata.socialAccounts![accountIndex] = providerId + ':' + value // update account
    }
    else {
      editMetadata.socialAccounts ??= []
      editMetadata.socialAccounts.push(providerId + ':' + value) // add account
    }
  }
}

function save() {
  saveChanges(async () => {
    const changes: PatchChange[] = []
    if (!userRef.value)
      return

    const metadata = userRef.value.metadata ?? new UserMetadata()
    
    for (const key of editProperties) {
      if (propertyChanged(metadata[key], editMetadata[key])) {
        const value = editMetadata[key] as PatchChangeValue
        changes.push(new PatchChange(`/metadata/${key}`, value == '' ? undefined : value))
      }
    }

    if (changes.length) {
      await userStore.patchAsync(userRef.value.id!, changes)
    }
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (userRef.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_2, [
          _createVNode(EditActions, {
            "edit-mode": { canEdit: _unref(canEdit), isEditing: _unref(isEditing), canSave: _unref(canSave), saveText: _unref(saveText), canCancel: _unref(canCancel) },
            "edit-text": "Edit user profile",
            onEdit: _unref(edit),
            onSave: save,
            onCancel: _unref(cancel)
          }, null, 8, ["edit-mode", "onEdit", "onCancel"]),
          (_unref(isEditing))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editMetadata.location) = $event)),
                    readonly: !_unref(canEditValues),
                    placeholder: "city, state, country"
                  }, null, 8, _hoisted_6), [
                    [_vModelText, editMetadata.location]
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(" Suggested: " + _toDisplayString(suggestedLocationRef.value) + " ", 1),
                    (suggestedLocationRef.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-inline btn-link",
                          onClick: useSuggestedLocation
                        }, " Use this "))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isEditing))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("ul", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialAccountProviders), (p) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: p.id
                      }, [
                        _createElementVNode("img", {
                          src: p.icon,
                          alt: p.name
                        }, null, 8, _hoisted_12),
                        _hoisted_13,
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          value: editMetadata.getSocialUsernameFor(p.id),
                          onInput: e => onSocialAccountChange(e, p.id),
                          placeholder: "username"
                        }, null, 40, _hoisted_14)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isEditing) || userRef.value.metadata?.genealogyStartYear)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  (_unref(isEditing))
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: "text",
                        id: "startYearInput",
                        class: "form-control",
                        readonly: !_unref(canEditValues),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editMetadata.genealogyStartYear) = $event)),
                        pattern: "\\d*",
                        maxlength: "4",
                        inputmode: "numeric",
                        placeholder: "year"
                      }, null, 8, _hoisted_18)), [
                        [_vModelText, editMetadata.genealogyStartYear]
                      ])
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(userRef.value.metadata?.genealogyStartYear) + " ", 1),
                    _createElementVNode("span", _hoisted_20, "(" + _toDisplayString(startYearAgoRef.value) + " yrs)", 1)
                  ], 512), [
                    [_vShow, !_unref(isEditing)]
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_unref(isEditing) || userRef.value.metadata?.researchTools?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(researchToolsRef.value, (tid) => {
                      return (_openBlock(), _createElementBlock("li", { key: tid }, [
                        _createVNode(ResearchToolItem, { toolId: tid }, null, 8, ["toolId"])
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_25, [
                      (_unref(isEditing))
                        ? (_openBlock(), _createElementBlock("button", _hoisted_26, " + "))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(ResearchToolsModal, {
      id: "researchToolsModal",
      modelValue: researchToolsRef.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((researchToolsRef).value = $event))
    }, null, 8, ["modelValue"])
  ]))
}
}

})